/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LocaleRouteRouteImport } from './routes/$locale/route'
import { Route as LocalePartnerRouteRouteImport } from './routes/$locale/$partner/route'
import { Route as LocalePartnerConditionsRouteImport } from './routes/$locale/$partner/conditions'
import { Route as LocalePartnerDeviceReceiptConfirmationRouteImport } from './routes/$locale/$partner/device-receipt-confirmation'
import { Route as LocalePartnerFormRouteImport } from './routes/$locale/$partner/form'
import { Route as LocalePartnerHomeRouteImport } from './routes/$locale/$partner/home'
import { Route as LocalePartnerOfferRouteImport } from './routes/$locale/$partner/offer'
import { Route as LocalePartnerPricingRouteImport } from './routes/$locale/$partner/pricing'
import { Route as LocalePartnerSignatureRouteImport } from './routes/$locale/$partner/signature'
import { Route as LocalePartnerSuccessRouteImport } from './routes/$locale/$partner/success'
import { Route as LocalePartnerTransactionsRouteImport } from './routes/$locale/$partner/transactions'
import { Route as LocalePartnerRecyclingDeviceReceiptConfirmationRouteImport } from './routes/$locale/$partner/recycling/device-receipt-confirmation'
import { Route as LocalePartnerRecyclingFormRouteImport } from './routes/$locale/$partner/recycling/form'
import { Route as LocalePartnerRecyclingSuccessRouteImport } from './routes/$locale/$partner/recycling/success'
import { Route as LocalePartnerVoucherIndexRouteImport } from './routes/$locale/$partner/voucher/index'
import { Route as LocalePartnerVoucherVoucherCodeRouteImport } from './routes/$locale/$partner/voucher/$voucherCode'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const LocaleRouteRoute = LocaleRouteRouteImport.update({
  id: '/$locale',
  path: '/$locale',
  getParentRoute: () => rootRouteImport,
} as any)
const LocalePartnerRouteRoute = LocalePartnerRouteRouteImport.update({
  id: '/$partner',
  path: '/$partner',
  getParentRoute: () => LocaleRouteRoute,
} as any)
const LocalePartnerConditionsRoute = LocalePartnerConditionsRouteImport.update({
  id: '/conditions',
  path: '/conditions',
  getParentRoute: () => LocalePartnerRouteRoute,
} as any)
const LocalePartnerDeviceReceiptConfirmationRoute =
  LocalePartnerDeviceReceiptConfirmationRouteImport.update({
    id: '/device-receipt-confirmation',
    path: '/device-receipt-confirmation',
    getParentRoute: () => LocalePartnerRouteRoute,
  } as any)
const LocalePartnerFormRoute = LocalePartnerFormRouteImport.update({
  id: '/form',
  path: '/form',
  getParentRoute: () => LocalePartnerRouteRoute,
} as any)
const LocalePartnerHomeRoute = LocalePartnerHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => LocalePartnerRouteRoute,
} as any)
const LocalePartnerOfferRoute = LocalePartnerOfferRouteImport.update({
  id: '/offer',
  path: '/offer',
  getParentRoute: () => LocalePartnerRouteRoute,
} as any)
const LocalePartnerPricingRoute = LocalePartnerPricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => LocalePartnerRouteRoute,
} as any)
const LocalePartnerSignatureRoute = LocalePartnerSignatureRouteImport.update({
  id: '/signature',
  path: '/signature',
  getParentRoute: () => LocalePartnerRouteRoute,
} as any)
const LocalePartnerSuccessRoute = LocalePartnerSuccessRouteImport.update({
  id: '/success',
  path: '/success',
  getParentRoute: () => LocalePartnerRouteRoute,
} as any)
const LocalePartnerTransactionsRoute =
  LocalePartnerTransactionsRouteImport.update({
    id: '/transactions',
    path: '/transactions',
    getParentRoute: () => LocalePartnerRouteRoute,
  } as any)
const LocalePartnerRecyclingDeviceReceiptConfirmationRoute =
  LocalePartnerRecyclingDeviceReceiptConfirmationRouteImport.update({
    id: '/recycling/device-receipt-confirmation',
    path: '/recycling/device-receipt-confirmation',
    getParentRoute: () => LocalePartnerRouteRoute,
  } as any)
const LocalePartnerRecyclingFormRoute =
  LocalePartnerRecyclingFormRouteImport.update({
    id: '/recycling/form',
    path: '/recycling/form',
    getParentRoute: () => LocalePartnerRouteRoute,
  } as any)
const LocalePartnerRecyclingSuccessRoute =
  LocalePartnerRecyclingSuccessRouteImport.update({
    id: '/recycling/success',
    path: '/recycling/success',
    getParentRoute: () => LocalePartnerRouteRoute,
  } as any)
const LocalePartnerVoucherIndexRoute =
  LocalePartnerVoucherIndexRouteImport.update({
    id: '/voucher/',
    path: '/voucher/',
    getParentRoute: () => LocalePartnerRouteRoute,
  } as any)
const LocalePartnerVoucherVoucherCodeRoute =
  LocalePartnerVoucherVoucherCodeRouteImport.update({
    id: '/voucher/$voucherCode',
    path: '/voucher/$voucherCode',
    getParentRoute: () => LocalePartnerRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$locale': typeof LocaleRouteRouteWithChildren
  '/$locale/$partner': typeof LocalePartnerRouteRouteWithChildren
  '/$locale/$partner/conditions': typeof LocalePartnerConditionsRoute
  '/$locale/$partner/device-receipt-confirmation': typeof LocalePartnerDeviceReceiptConfirmationRoute
  '/$locale/$partner/form': typeof LocalePartnerFormRoute
  '/$locale/$partner/home': typeof LocalePartnerHomeRoute
  '/$locale/$partner/offer': typeof LocalePartnerOfferRoute
  '/$locale/$partner/pricing': typeof LocalePartnerPricingRoute
  '/$locale/$partner/signature': typeof LocalePartnerSignatureRoute
  '/$locale/$partner/success': typeof LocalePartnerSuccessRoute
  '/$locale/$partner/transactions': typeof LocalePartnerTransactionsRoute
  '/$locale/$partner/recycling/device-receipt-confirmation': typeof LocalePartnerRecyclingDeviceReceiptConfirmationRoute
  '/$locale/$partner/recycling/form': typeof LocalePartnerRecyclingFormRoute
  '/$locale/$partner/recycling/success': typeof LocalePartnerRecyclingSuccessRoute
  '/$locale/$partner/voucher/$voucherCode': typeof LocalePartnerVoucherVoucherCodeRoute
  '/$locale/$partner/voucher/': typeof LocalePartnerVoucherIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$locale': typeof LocaleRouteRouteWithChildren
  '/$locale/$partner': typeof LocalePartnerRouteRouteWithChildren
  '/$locale/$partner/conditions': typeof LocalePartnerConditionsRoute
  '/$locale/$partner/device-receipt-confirmation': typeof LocalePartnerDeviceReceiptConfirmationRoute
  '/$locale/$partner/form': typeof LocalePartnerFormRoute
  '/$locale/$partner/home': typeof LocalePartnerHomeRoute
  '/$locale/$partner/offer': typeof LocalePartnerOfferRoute
  '/$locale/$partner/pricing': typeof LocalePartnerPricingRoute
  '/$locale/$partner/signature': typeof LocalePartnerSignatureRoute
  '/$locale/$partner/success': typeof LocalePartnerSuccessRoute
  '/$locale/$partner/transactions': typeof LocalePartnerTransactionsRoute
  '/$locale/$partner/recycling/device-receipt-confirmation': typeof LocalePartnerRecyclingDeviceReceiptConfirmationRoute
  '/$locale/$partner/recycling/form': typeof LocalePartnerRecyclingFormRoute
  '/$locale/$partner/recycling/success': typeof LocalePartnerRecyclingSuccessRoute
  '/$locale/$partner/voucher/$voucherCode': typeof LocalePartnerVoucherVoucherCodeRoute
  '/$locale/$partner/voucher': typeof LocalePartnerVoucherIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$locale': typeof LocaleRouteRouteWithChildren
  '/$locale/$partner': typeof LocalePartnerRouteRouteWithChildren
  '/$locale/$partner/conditions': typeof LocalePartnerConditionsRoute
  '/$locale/$partner/device-receipt-confirmation': typeof LocalePartnerDeviceReceiptConfirmationRoute
  '/$locale/$partner/form': typeof LocalePartnerFormRoute
  '/$locale/$partner/home': typeof LocalePartnerHomeRoute
  '/$locale/$partner/offer': typeof LocalePartnerOfferRoute
  '/$locale/$partner/pricing': typeof LocalePartnerPricingRoute
  '/$locale/$partner/signature': typeof LocalePartnerSignatureRoute
  '/$locale/$partner/success': typeof LocalePartnerSuccessRoute
  '/$locale/$partner/transactions': typeof LocalePartnerTransactionsRoute
  '/$locale/$partner/recycling/device-receipt-confirmation': typeof LocalePartnerRecyclingDeviceReceiptConfirmationRoute
  '/$locale/$partner/recycling/form': typeof LocalePartnerRecyclingFormRoute
  '/$locale/$partner/recycling/success': typeof LocalePartnerRecyclingSuccessRoute
  '/$locale/$partner/voucher/$voucherCode': typeof LocalePartnerVoucherVoucherCodeRoute
  '/$locale/$partner/voucher/': typeof LocalePartnerVoucherIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$locale'
    | '/$locale/$partner'
    | '/$locale/$partner/conditions'
    | '/$locale/$partner/device-receipt-confirmation'
    | '/$locale/$partner/form'
    | '/$locale/$partner/home'
    | '/$locale/$partner/offer'
    | '/$locale/$partner/pricing'
    | '/$locale/$partner/signature'
    | '/$locale/$partner/success'
    | '/$locale/$partner/transactions'
    | '/$locale/$partner/recycling/device-receipt-confirmation'
    | '/$locale/$partner/recycling/form'
    | '/$locale/$partner/recycling/success'
    | '/$locale/$partner/voucher/$voucherCode'
    | '/$locale/$partner/voucher/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$locale'
    | '/$locale/$partner'
    | '/$locale/$partner/conditions'
    | '/$locale/$partner/device-receipt-confirmation'
    | '/$locale/$partner/form'
    | '/$locale/$partner/home'
    | '/$locale/$partner/offer'
    | '/$locale/$partner/pricing'
    | '/$locale/$partner/signature'
    | '/$locale/$partner/success'
    | '/$locale/$partner/transactions'
    | '/$locale/$partner/recycling/device-receipt-confirmation'
    | '/$locale/$partner/recycling/form'
    | '/$locale/$partner/recycling/success'
    | '/$locale/$partner/voucher/$voucherCode'
    | '/$locale/$partner/voucher'
  id:
    | '__root__'
    | '/'
    | '/$locale'
    | '/$locale/$partner'
    | '/$locale/$partner/conditions'
    | '/$locale/$partner/device-receipt-confirmation'
    | '/$locale/$partner/form'
    | '/$locale/$partner/home'
    | '/$locale/$partner/offer'
    | '/$locale/$partner/pricing'
    | '/$locale/$partner/signature'
    | '/$locale/$partner/success'
    | '/$locale/$partner/transactions'
    | '/$locale/$partner/recycling/device-receipt-confirmation'
    | '/$locale/$partner/recycling/form'
    | '/$locale/$partner/recycling/success'
    | '/$locale/$partner/voucher/$voucherCode'
    | '/$locale/$partner/voucher/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LocaleRouteRoute: typeof LocaleRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$locale': {
      id: '/$locale'
      path: '/$locale'
      fullPath: '/$locale'
      preLoaderRoute: typeof LocaleRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$locale/$partner': {
      id: '/$locale/$partner'
      path: '/$partner'
      fullPath: '/$locale/$partner'
      preLoaderRoute: typeof LocalePartnerRouteRouteImport
      parentRoute: typeof LocaleRouteRoute
    }
    '/$locale/$partner/conditions': {
      id: '/$locale/$partner/conditions'
      path: '/conditions'
      fullPath: '/$locale/$partner/conditions'
      preLoaderRoute: typeof LocalePartnerConditionsRouteImport
      parentRoute: typeof LocalePartnerRouteRoute
    }
    '/$locale/$partner/device-receipt-confirmation': {
      id: '/$locale/$partner/device-receipt-confirmation'
      path: '/device-receipt-confirmation'
      fullPath: '/$locale/$partner/device-receipt-confirmation'
      preLoaderRoute: typeof LocalePartnerDeviceReceiptConfirmationRouteImport
      parentRoute: typeof LocalePartnerRouteRoute
    }
    '/$locale/$partner/form': {
      id: '/$locale/$partner/form'
      path: '/form'
      fullPath: '/$locale/$partner/form'
      preLoaderRoute: typeof LocalePartnerFormRouteImport
      parentRoute: typeof LocalePartnerRouteRoute
    }
    '/$locale/$partner/home': {
      id: '/$locale/$partner/home'
      path: '/home'
      fullPath: '/$locale/$partner/home'
      preLoaderRoute: typeof LocalePartnerHomeRouteImport
      parentRoute: typeof LocalePartnerRouteRoute
    }
    '/$locale/$partner/offer': {
      id: '/$locale/$partner/offer'
      path: '/offer'
      fullPath: '/$locale/$partner/offer'
      preLoaderRoute: typeof LocalePartnerOfferRouteImport
      parentRoute: typeof LocalePartnerRouteRoute
    }
    '/$locale/$partner/pricing': {
      id: '/$locale/$partner/pricing'
      path: '/pricing'
      fullPath: '/$locale/$partner/pricing'
      preLoaderRoute: typeof LocalePartnerPricingRouteImport
      parentRoute: typeof LocalePartnerRouteRoute
    }
    '/$locale/$partner/signature': {
      id: '/$locale/$partner/signature'
      path: '/signature'
      fullPath: '/$locale/$partner/signature'
      preLoaderRoute: typeof LocalePartnerSignatureRouteImport
      parentRoute: typeof LocalePartnerRouteRoute
    }
    '/$locale/$partner/success': {
      id: '/$locale/$partner/success'
      path: '/success'
      fullPath: '/$locale/$partner/success'
      preLoaderRoute: typeof LocalePartnerSuccessRouteImport
      parentRoute: typeof LocalePartnerRouteRoute
    }
    '/$locale/$partner/transactions': {
      id: '/$locale/$partner/transactions'
      path: '/transactions'
      fullPath: '/$locale/$partner/transactions'
      preLoaderRoute: typeof LocalePartnerTransactionsRouteImport
      parentRoute: typeof LocalePartnerRouteRoute
    }
    '/$locale/$partner/recycling/device-receipt-confirmation': {
      id: '/$locale/$partner/recycling/device-receipt-confirmation'
      path: '/recycling/device-receipt-confirmation'
      fullPath: '/$locale/$partner/recycling/device-receipt-confirmation'
      preLoaderRoute: typeof LocalePartnerRecyclingDeviceReceiptConfirmationRouteImport
      parentRoute: typeof LocalePartnerRouteRoute
    }
    '/$locale/$partner/recycling/form': {
      id: '/$locale/$partner/recycling/form'
      path: '/recycling/form'
      fullPath: '/$locale/$partner/recycling/form'
      preLoaderRoute: typeof LocalePartnerRecyclingFormRouteImport
      parentRoute: typeof LocalePartnerRouteRoute
    }
    '/$locale/$partner/recycling/success': {
      id: '/$locale/$partner/recycling/success'
      path: '/recycling/success'
      fullPath: '/$locale/$partner/recycling/success'
      preLoaderRoute: typeof LocalePartnerRecyclingSuccessRouteImport
      parentRoute: typeof LocalePartnerRouteRoute
    }
    '/$locale/$partner/voucher/': {
      id: '/$locale/$partner/voucher/'
      path: '/voucher'
      fullPath: '/$locale/$partner/voucher/'
      preLoaderRoute: typeof LocalePartnerVoucherIndexRouteImport
      parentRoute: typeof LocalePartnerRouteRoute
    }
    '/$locale/$partner/voucher/$voucherCode': {
      id: '/$locale/$partner/voucher/$voucherCode'
      path: '/voucher/$voucherCode'
      fullPath: '/$locale/$partner/voucher/$voucherCode'
      preLoaderRoute: typeof LocalePartnerVoucherVoucherCodeRouteImport
      parentRoute: typeof LocalePartnerRouteRoute
    }
  }
}

interface LocalePartnerRouteRouteChildren {
  LocalePartnerConditionsRoute: typeof LocalePartnerConditionsRoute
  LocalePartnerDeviceReceiptConfirmationRoute: typeof LocalePartnerDeviceReceiptConfirmationRoute
  LocalePartnerFormRoute: typeof LocalePartnerFormRoute
  LocalePartnerHomeRoute: typeof LocalePartnerHomeRoute
  LocalePartnerOfferRoute: typeof LocalePartnerOfferRoute
  LocalePartnerPricingRoute: typeof LocalePartnerPricingRoute
  LocalePartnerSignatureRoute: typeof LocalePartnerSignatureRoute
  LocalePartnerSuccessRoute: typeof LocalePartnerSuccessRoute
  LocalePartnerTransactionsRoute: typeof LocalePartnerTransactionsRoute
  LocalePartnerRecyclingDeviceReceiptConfirmationRoute: typeof LocalePartnerRecyclingDeviceReceiptConfirmationRoute
  LocalePartnerRecyclingFormRoute: typeof LocalePartnerRecyclingFormRoute
  LocalePartnerRecyclingSuccessRoute: typeof LocalePartnerRecyclingSuccessRoute
  LocalePartnerVoucherVoucherCodeRoute: typeof LocalePartnerVoucherVoucherCodeRoute
  LocalePartnerVoucherIndexRoute: typeof LocalePartnerVoucherIndexRoute
}

const LocalePartnerRouteRouteChildren: LocalePartnerRouteRouteChildren = {
  LocalePartnerConditionsRoute: LocalePartnerConditionsRoute,
  LocalePartnerDeviceReceiptConfirmationRoute:
    LocalePartnerDeviceReceiptConfirmationRoute,
  LocalePartnerFormRoute: LocalePartnerFormRoute,
  LocalePartnerHomeRoute: LocalePartnerHomeRoute,
  LocalePartnerOfferRoute: LocalePartnerOfferRoute,
  LocalePartnerPricingRoute: LocalePartnerPricingRoute,
  LocalePartnerSignatureRoute: LocalePartnerSignatureRoute,
  LocalePartnerSuccessRoute: LocalePartnerSuccessRoute,
  LocalePartnerTransactionsRoute: LocalePartnerTransactionsRoute,
  LocalePartnerRecyclingDeviceReceiptConfirmationRoute:
    LocalePartnerRecyclingDeviceReceiptConfirmationRoute,
  LocalePartnerRecyclingFormRoute: LocalePartnerRecyclingFormRoute,
  LocalePartnerRecyclingSuccessRoute: LocalePartnerRecyclingSuccessRoute,
  LocalePartnerVoucherVoucherCodeRoute: LocalePartnerVoucherVoucherCodeRoute,
  LocalePartnerVoucherIndexRoute: LocalePartnerVoucherIndexRoute,
}

const LocalePartnerRouteRouteWithChildren =
  LocalePartnerRouteRoute._addFileChildren(LocalePartnerRouteRouteChildren)

interface LocaleRouteRouteChildren {
  LocalePartnerRouteRoute: typeof LocalePartnerRouteRouteWithChildren
}

const LocaleRouteRouteChildren: LocaleRouteRouteChildren = {
  LocalePartnerRouteRoute: LocalePartnerRouteRouteWithChildren,
}

const LocaleRouteRouteWithChildren = LocaleRouteRoute._addFileChildren(
  LocaleRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LocaleRouteRoute: LocaleRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
